"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatch = require("crm_data/flux/dispatch");

var _LinkedSalesObjectAPI = _interopRequireDefault(require("crm_ui/api/integrations/LinkedSalesObjectAPI"));

var _LinkedSalesObjectActionTypes = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectActionTypes"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _immutable = require("immutable");

var _pick = _interopRequireDefault(require("transmute/pick"));

var _Raven = _interopRequireDefault(require("Raven"));

var _getKey = function _getKey(resp, key) {
  if (!_immutable.Map.isMap(resp) || !resp.get('message')) {
    return "profileSidebarModule.integrations." + key;
  } else {
    return resp.get('message');
  }
};

var notifyActionSuccess = function notifyActionSuccess(actionLabel, resp) {
  var options = {
    action: actionLabel
  };

  var message = _getKey(resp, 'linkedSalesObjectActionSuccess');

  return (0, _Alerts.addSuccess)(message, options);
};

var notifyActionFailure = function notifyActionFailure(actionLabel, resp) {
  var options = {
    action: actionLabel
  };

  var message = _getKey(resp, 'linkedSalesObjectActionFailure');

  return (0, _Alerts.addError)(message, options);
};

var fetchObjects = function fetchObjects(_ref) {
  var objectTypeId = _ref.objectTypeId,
      associatedObjectId = _ref.associatedObjectId,
      associatedObjectType = _ref.associatedObjectType;
  return _LinkedSalesObjectAPI.default.fetch({
    objectTypeId: objectTypeId,
    associatedObjectId: associatedObjectId,
    associatedObjectType: associatedObjectType
  }).then(function (content) {
    return (0, _dispatch.dispatch)(_LinkedSalesObjectActionTypes.default.FETCH_SUCCEEDED, {
      objectTypeId: objectTypeId,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      content: content
    });
  }).catch(function (err) {
    return (0, _dispatch.dispatch)(_LinkedSalesObjectActionTypes.default.FETCH_FAILED, {
      objectTypeId: objectTypeId,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      err: err
    });
  });
};

var _default = {
  fetch: fetchObjects,
  doActionHook: function doActionHook(action, actionLabel) {
    return _LinkedSalesObjectAPI.default.doActionHook(action).then(function (resp) {
      fetchObjects((0, _pick.default)(['objectTypeId', 'associatedObjectId', 'associatedObjectType'], action));
      notifyActionSuccess(actionLabel, resp);
      return (0, _dispatch.dispatch)(_LinkedSalesObjectActionTypes.default.ACTION_SUCCEEDED);
    }).catch(function (err) {
      _Raven.default.captureMessage('Linked sales object action failed.', {
        extra: {
          statusCode: err.status,
          response: err.responseText,
          action: action,
          actionLabel: actionLabel
        }
      });

      notifyActionFailure(actionLabel, err);
      return (0, _dispatch.dispatch)(_LinkedSalesObjectActionTypes.default.ACTION_FAILED);
    });
  }
};
exports.default = _default;
module.exports = exports.default;